import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createLead = (data) => axios.post(`${API}/leads`, data).then(r => r.data);
export const listLeads = (password) =>
    axios.get(`${API}/leads`, { headers: { "X-Admin-Password": password } }).then(r => r.data);
export const verifyAdmin = (password) =>
    axios.post(`${API}/admin/verify`, {}, { headers: { "X-Admin-Password": password } }).then(r => r.data);
export const trackEvent = (event_name, payload = {}) =>
    axios.post(`${API}/analytics/event`, { event_name, payload }).catch(() => null);
